import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  rightsGroup: []
}

export const mutations = {
  SET_RIGHTS_GROUP(state, rightsGroup) {
    state.rightsGroup = rightsGroup
  },
  ADD_RIGHT_GROUP(state, rightGroup) {
    state.rightsGroup.push(rightGroup)
  },
  EDIT_RIGHT_GROUP(state, rightGroup) {
    const index = state.rightsGroup.findIndex(
      element => element.authority_uuid === rightGroup.authority_uuid
    )
    if (index !== -1) {
      state.rightsGroup.splice(index, 1, rightGroup)
    }
  },
  DELETE_RIGHT_GROUP(state, authority_uuid) {
    const index = state.rightsGroup.findIndex(
      element => element.authority_uuid === authority_uuid
    )
    if (index !== -1) state.rightsGroup.splice(index, 1)
  }
}

export const actions = {
  fetchRightsGroup({ commit }, payload) {
    return ApiService.fetchRightsGroup(payload)
      .then(res => {
        const rightsGroup = res.data.data
        commit('SET_RIGHTS_GROUP', rightsGroup)
      })
      .catch(error => {
        throw error
      })
  },
  addRightGroup({ commit }, payload) {
    return ApiService.addRightGroup(payload)
      .then(res => {
        const rightGroup = res.data
        commit('ADD_RIGHT_GROUP', rightGroup)
      })
      .catch(error => {
        throw error
      })
  },
  editRightGroup({ commit }, payload) {
    return ApiService.editRightGroup(payload)
      .then(res => {
        const rightGroup = res.data
        commit('EDIT_RIGHT_GROUP', rightGroup)
      })
      .catch(error => {
        throw error
      })
  },
  deleteRightGroup({ commit }, payload) {
    return ApiService.deleteRightGroup(payload)
      .then(() => {
        commit('DELETE_RIGHT_GROUP', payload.authority_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}
